import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense, useMemo, useState } from 'react'
import { Outlet } from 'react-router'

export type ProjectsOutletContext = {
  view: 'cards' | 'table'
  setView: (view: 'cards' | 'table') => void
}

export const ProjectsRootLayout = () => {
  const [view, setView] = useState<'cards' | 'table'>('cards')
  const outletContext: ProjectsOutletContext = useMemo(
    () => ({
      view,
      setView,
    }),
    [view]
  )
  return (
    <Suspense fallback={<LoadingComponent />}>
      <Outlet context={outletContext} />
    </Suspense>
  )
}
